import type { StationStore } from './store';
import type { ReturnNotice } from './sync';

/**
 * Hinweise zu nachgesendeten Rückgabe-Scans (z. B. „Verkauft“), im Speicher der Station je Person (wie die abgelehnten Scans der
 * Annahme): Sie gehören der Person, die gescannt hat, überleben das Neuladen und das Abmelden (der Lauf vor dem Abmelden sendet
 * noch) und bleiben stehen, bis sie gelesen sind.
 */
const NOTICES_KEY = 'notices';
const NOTICES_MAX = 100;

export interface StoredNotice extends ReturnNotice {
  userId: string | null;
  at: number;
}

export async function addNotice(store: StationStore, entry: StoredNotice): Promise<void> {
  const all = (await store.getMeta<StoredNotice[]>(NOTICES_KEY)) ?? [];
  await store.setMeta(NOTICES_KEY, [...all, entry].slice(-NOTICES_MAX));
}

/** Ungelesene Hinweise dieser Person, älteste zuerst. */
export async function listNotices(
  store: StationStore,
  person: string | null,
): Promise<ReturnNotice[]> {
  const all = (await store.getMeta<StoredNotice[]>(NOTICES_KEY)) ?? [];
  return all
    .filter((entry) => entry.userId === person)
    .map(({ code, result }): ReturnNotice => ({ code, result }));
}

/** Die Hinweise einer Person als gelesen entfernen. */
export async function dismissStoredNotices(
  store: StationStore,
  person: string | null,
): Promise<void> {
  const all = (await store.getMeta<StoredNotice[]>(NOTICES_KEY)) ?? [];
  await store.setMeta(
    NOTICES_KEY,
    all.filter((entry) => entry.userId !== person),
  );
}
